export default "__VITE_ASSET__DT1AMT17__"